import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/app/(pages)/fs/@section1/page.tsx");
